import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { environment } from '@env';

import { SusUser } from '../../view-models/sus-user-view-model';

@Injectable({
  providedIn: 'root',
})
export class CnsApiProviderService {
  constructor(private apiService: ApiService) {}

  getUserDataByCNS(cns: string) {
    const endpoint = `${environment.environmentVariables.apiAuthUrl}/cns/auto-complete/cns/${cns}`;
    return this.apiService.get<SusUser>(endpoint);
  }

  getUserDataByCPF(cpf: string) {
    const endpoint = `${environment.environmentVariables.apiAuthUrl}/cns/auto-complete/cpf/${cpf}`;
    return this.apiService.get<SusUser>(endpoint);
  }

  validateCns(cns: string) {
    const endpoint = `${environment.environmentVariables.apiAuthUrl}/cns/doctor/is-valid-cns/${cns}`;
    return this.apiService.get<boolean>(endpoint);
  }
}
